// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","notificationsList":"_2OqjJ1wg4FJPqNhuscIhDT","markAllRead":"_1IXf8prUThmr8SPqXZVg39"};